import React, { useEffect } from "react";
import isEmpty from "lodash/isEmpty";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "./redux/rawDataTableReducer";
import LoadingAnimation from "../../components/loadingAnimation/loadingAnimation";
import PollingRequest from "../../utils/polling-request";
import { RawDataTable } from "./smartComponents/rawDataTable";
import { DataPoints } from "./smartComponents/dataPoints";

export const RawDataTableModule = ({ queryParams }) => {
  const dispatch = useDispatch();

  const isLoading = useSelector((state) => state.rawDataTable.isLoading);
  const progress = useSelector((state) => state.rawDataTable.progress);

  useEffect(() => {
    startPolling();
  }, []);

  const startPolling = () => {
    new PollingRequest({
      query: queryParams,
      success: success,
      progress: onProgress,
      error: error
    }).start(() => {
      dispatch(actionCreators.setLoading(true));
    });
  };

  const success = (response) => {
    dispatch(actionCreators.fetchTableDataSuccess({ ...response, currentUser: queryParams }));

    // show ScrollTopButton
    const event = new Event("raw-data-loaded");
    document.dispatchEvent(event);
  };

  const error = (response) => {
    console.log(response);
  };

  const onProgress = (progress) => {
    dispatch(actionCreators.updateProgress(progress));
  };

  const renderLoading = () => {
    const progressPercent = (progress.current / progress.total) * 100;
    const progressText = isEmpty(progress) ? "" : `${Math.ceil(progressPercent)}%`;

    return <LoadingAnimation height="100vh" text={`Loading... ${progressText}`} />;
  };

  const { showDataPoints, table_name, width } = queryParams;

  return (
    <>
      {showDataPoints ? <DataPoints /> : null}

      <div className="raw-data-table" id={table_name}>
        {isLoading ? (
          renderLoading()
        ) : (
          <>
            <div className="md-handson-table">
              <div className="hot__flex" style={{ width: width }}>
                <RawDataTable startPolling={startPolling} />
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};
